// Offline / queued status banner for Tyler's Fabrication Dashboard employee
// app. Shows when the device is offline OR there are punches queued waiting
// to sync. Click flushes the queue manually.

import { useEffect, useState } from 'react'
import { subscribeQueueStatus, flushQueue, makeSupabaseSender } from '../lib/offlineQueue'

export function OfflineBanner({ supabase }) {
  const [state, setState] = useState({ pending: 0, online: navigator.onLine, syncing: false })

  useEffect(() => subscribeQueueStatus(setState), [])

  if (state.online && state.pending === 0) return null

  const offline = !state.online
  const label = offline
    ? `Offline — ${state.pending} punch${state.pending === 1 ? '' : 'es'} queued`
    : state.syncing
      ? `Syncing ${state.pending} punch${state.pending === 1 ? '' : 'es'}…`
      : `${state.pending} punch${state.pending === 1 ? '' : 'es'} queued — click to send`

  const bg = offline ? '#c2410c' : '#1d4ed8'

  return (
    <div
      role="status"
      onClick={async () => {
        if (offline || state.syncing) return
        await flushQueue(makeSupabaseSender(supabase))
      }}
      style={{
        position: 'sticky',
        top: 0,
        zIndex: 60,
        background: bg,
        color: 'white',
        padding: '8px 16px',
        fontWeight: 600,
        textAlign: 'center',
        cursor: offline ? 'default' : 'pointer',
      }}
    >
      {offline ? '⚠ ' : '⟳ '}
      {label}
    </div>
  )
}
